import { Typography } from '@repo/ui';
import { clearPortalImpersonationCookies } from '@repo/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import {
  appendResponseHeader,
  getWebRequest,
} from '@tanstack/react-start/server';
import { deleteJWTToken } from '~/utils/jwt';

/**
 * Server function to handle logout.
 * It clears all authentication cookies and redirects to the login page.
 */
const logoutServerFn = createServerFn({ method: 'POST' }).handler(async () => {
  const request = getWebRequest();
  const responseHeaders = new Headers();
  const context = { request, responseHeaders };

  deleteJWTToken(context);
  clearPortalImpersonationCookies({ context });

  for (const cookie of responseHeaders.getSetCookie()) {
    appendResponseHeader('set-cookie', cookie);
  }
});

// Route definition with a loader that triggers the server-side logout function
export const Route = createFileRoute('/_public/logout')({
  preload: false,
  beforeLoad: async ({ context }) => {
    context.queryClient.clear();
    await logoutServerFn();
    throw redirect({ to: '/login' });
  },
  component: () => (
    <div>
      <Typography as='h1' variant='heading-xl'>
        Logging out...
      </Typography>
      <Typography as='p' variant='body-s'>
        You will be redirected shortly.
      </Typography>
    </div>
  ),
});
